import { useEffect, useState } from 'react';

import { DepartureOption, DepartureOptions } from '@lt/api/dist/types/departure';

import { useIsMounted } from 'usehooks-ts';

import { storageKeys } from '../constants';
import { useGetApiClient } from '../../../context/apiContext';
import useReadLocalStorageWithDTO from './useReadLocalStorageWithDTO';
import { savedDepartureDTO } from '../utils/savedDepartureDTO';

export const useFetchDepartures = () => {
  const [departures, setDepartures] = useState<DepartureOptions | null>(null);
  const [loading, setLoading] = useState(false);
  const isMounted = useIsMounted();
  const api = useGetApiClient();

  const savedDeparture = useReadLocalStorageWithDTO<DepartureOption>(
    storageKeys.departure,
    savedDepartureDTO
  );

  const [popupCityName, setPopupCityName] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    const fetchDepartures = async () => {
      if (!api) {
        return;
      }
      const departureOptions: DepartureOptions = await api.getReferencesClientDepartures({
        city: savedDeparture?.value,
        automatically_detect_city: true,
      });

      if (isMounted()) {
        const detectedOption = departureOptions.find(({ isAutomaticallyDetected }) =>
          Boolean(isAutomaticallyDetected)
        );
        setPopupCityName(detectedOption?.label || '');
        setDepartures(departureOptions);
      }
    };

    fetchDepartures()
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  }, [isMounted, savedDeparture?.value]);

  return {
    departures,
    loading,
    popupCityName,
    setPopupCityName,
  };
};
